(function ($) {$(function(){
    window.$grid = $('.mgrid').masonry({
        itemSelector: '.grid-item',
        columnWidth: '.grid-sizer',
        // transitionDuration: '0.2s',
        percentPosition: true,
        gutter: 5,
        // horizontalOrder: true
    });
    updateGridItemHeight();
    contactFormBoxSize();
});}(_jQ3));

window.addEventListener('resize', updateGridItemHeight);
window.addEventListener('resize', contactFormBoxSize);

function updateGridItemHeight(){
    var $grid = _jQ3('#mgrid');
    var $instaStats = _jQ3('.instafeed');
    var $gridSizer = _jQ3('#grid-sizer');
    if ($grid) {
        $grid.css('--base-height', Math.floor($gridSizer.width()) + 'px');
        $instaStats.css('--base-height', Math.floor($gridSizer.width()) + 'px');
        window.$grid.masonry('layout');
    }
}

function contactFormBoxSize(){
    var $boxContainer = _jQ3('.newsletter-form');
    if ($boxContainer.length) {
        var width = $boxContainer.width();
        var height = $boxContainer.height();
        $boxContainer.css('--box-width', width + 'px');
        $boxContainer.css('--box-height', height + 'px');
    }
}